import { NavLink } from "hooks/useCustomNavigation";
import "./index.scss";

export const RecommendedBrand = ({ image, title, slug }) => {
  const brandSlugHref = `/buy-${slug}-gift-cards`;
  return (
    <>
      <NavLink className="recommend-brand-logo" to={brandSlugHref}>
        <img
          src={image}
          alt={`${title} logo`}
          className="recommend-brand-image"
          data-testid="recommended-brand"
          height={129}
          width={129}
          importance="low"
          decoding="async"
          loading="lazy"
        />
      </NavLink>
      <NavLink to={brandSlugHref} className="recommend-brand-name">
        {title}
      </NavLink>
      <NavLink to={brandSlugHref} className="recommend-brand-action">
        SHOP NOW
      </NavLink>
    </>
  );
};
